export default __webpack_public_path__ + "static/media/speakers__alaina-kafkes.faa845e9.jpg";